import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import BreadCrum from "../../lib/BreadCrum";
import { USER_ROLES } from "../../utils/constant";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    InputAdornment,
    CircularProgress,
    TextField,
    Theme,
    Typography,
} from "@mui/material";
import theme from "../../themes/default";
import { InfoIconFilled, SearchIcon } from "../../assets/SvgIcons";
import OTPForm from "../../lib/formik/OtpForm";
import CustomTable from "../investorOverview/common/customTable";
import type { AddRemoveFamilyMemberReq, AddRemoveFamilyMemberRes, CreateFamilyPayload, CreateFamilyRes, MemberRow, OnboardedCustomerObj, OnboardedCustomersListRes, SendFamilyOtpRes, VerifyFamilyOtpRes } from "../../redux-store/types/investorProfile";
import { RootStateType } from "../../redux-store/reducers";
import { ConsentStatus } from "../../redux-store/types/api-types";
import { showError } from "../../redux-store/actions/auth";
import CreateFamilyMembersTableBody, {
    FamilyMembersTableHeader,
} from "./CreateFamilyMembersTableBody";
import SelectMemberTableBody, {
    selectMemberTableHeader,
} from "./SelectMemberTableBody";
import { addRemoveFamilyMember, createFamily, fetchOnboardedCustomersList, sendFamilyOtp, verifyFamilyOtp } from "../../redux-store/actions/investorProfile";
import { MAX_FAMILY_MEMBERS } from "../../utils/constant";
import { isRMLikeRole } from "../../utils/utilityFunctions";

type FamilynavigationData = {
    obj?: any;
    fromFamilyProfile?: boolean;
};

export default function CreateFamily(): JSX.Element {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState<string>("");
    const [familyName, setFamilyName] = useState<string>("");
    const [selectMemberOpen, setSelectMemberOpen] = useState<boolean>(false);
    const [selectedMemberIds, setSelectedMemberIds] = useState<string[]>([]);
    const [familyMembers, setFamilyMembers] = useState<MemberRow[]>([]);
    const [headOfFamilyId, setHeadOfFamilyId] = useState<string | null>(null);
    const [otpDialogOpen, setOtpDialogOpen] = useState<boolean>(false);
    const [otpDialogMemberId, setOtpDialogMemberId] = useState<string | null>(null);
    const [otpMessage, setOtpMessage] = useState<string>("");
    const [members, setMembers] = useState<OnboardedCustomerObj[]>([]);
    const [isMembersLoading, setIsMembersLoading] = useState<boolean>(false);
    const [otpSendingMemberId, setOtpSendingMemberId] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [isFamilyNameVerified, setIsFamilyNameVerified] = useState<boolean>(false);
    const [isHofVerified, setIsHofVerified] = useState<boolean>(false);
    const history = useHistory();
    const { pathname, state } = history.location;
    const navState = state as FamilynavigationData;
    const isAddFamilyMemberFlow = Boolean(navState?.obj?.familyName);
    const isFromFamilyProfile = Boolean(navState?.fromFamilyProfile);

    const initialRouter = pathname?.split('/').filter((item) => item !== '');
    const { role = "", userDetails } = useSelector((state: RootStateType) => state.auth);
    const { iwappRmId = "", isCustFamilyHead = "", clientInterfaceCode, panNo, email, investorName, mobile, minorFirstName = "", minorLastName = "" } = useSelector((state: RootStateType) => state.id);
    const minorFullName = `${minorFirstName} ${minorLastName}`;
    const displayInvestorName = minorFullName || (investorName ?? "");
    const [otpReference, setOtpReference] = useState<null | number>();
    const rmRouterPath = isAddFamilyMemberFlow
        ? isFromFamilyProfile
            ? [
                {
                    name: 'Dashboard',
                    path: '/dashboard',
                },
                {
                    name: navState?.obj?.familyName ?? ' ',
                    path: `/${initialRouter[0]}/family-profile/${navState?.obj?.familyID}`,
                    state: {
                        obj: navState?.obj,
                        familyId: navState?.obj?.familyID,
                    },
                },
                {
                    name: 'Add Family Member',
                    path: `/${initialRouter[0]}/${initialRouter[1]}`,
                },
            ]
            : [
            {
                name: 'Dashboard',
                path: '/dashboard',
            },
            {
                name: 'View Families',
                path: `/${initialRouter[0]}/viewFamily`,
            },
            {
                name: navState?.obj?.familyName ?? ' ',
                path: `/${initialRouter[0]}/familyDetails`,
                state: { obj: navState?.obj },
            },
            {
                name: 'Add Family Member',
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            },
        ]
        : [
            {
                name: 'Dashboard',
                path: '/dashboard',
            },
            {
                name: 'View Families',
                path: `/${initialRouter[0]}/viewFamily`,

            },
            {
                name: 'Create Family',
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            },
        ];
    const investorRouterPath = isAddFamilyMemberFlow
        ? (isFromFamilyProfile || isCustFamilyHead === 'Y')
            ? [
                {
                    name: 'Dashboard',
                    path: '/investor-dashboard',
                },
                {
                    name: navState?.obj?.familyName ?? 'Family',
                    path: `/${initialRouter[0]}/family-profile/${navState?.obj?.familyID}`,
                    state: {
                        familyId: navState?.obj?.familyID,
                        familyName: navState?.obj?.familyName,
                    },
                },
                {
                    name: 'Add  Member',
                    path: `/${initialRouter[0]}/${initialRouter[1]}`,
                },
            ]
            : [
            {
                name: 'Dashboard',
                path: '/investor-dashboard',
            },
            {
                name: 'View Families',
                path: `/${initialRouter[0]}/viewFamily`,
            },
            {
                name: navState?.obj?.familyName ?? 'Family',
                path: `/${initialRouter[0]}/familyDetails`,
                state: { obj: navState?.obj },
            },
            {
                name: 'Add  Member',
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            },
        ]
        : [
            {
                name: 'Dashboard',
                path: '/investor-dashboard',
            },
            {
                name: 'Create Family',
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            },
        ];

    const isSearchEnabled = searchText.trim().length > 0;


    const handleSearchClick = async () => {
        try {
            setIsMembersLoading(true);
            const response = await (dispatch(fetchOnboardedCustomersList({
                rmId: `${iwappRmId}`,
                isFamilyMapped: "N",
                search: searchText.trim(),
            })) as unknown as Promise<OnboardedCustomersListRes>);

            setMembers(response?.result ?? []);
            setSelectMemberOpen(true);
            setSelectedMemberIds(familyMembers.map((m) => m.id));
        } catch (error) {
            dispatch(showError((error as Error)?.message ?? "Unable to fetch members"));
        } finally {
            setIsMembersLoading(false);
        }
    };



    // Sync checkbox selection with family members whenever Select Member dialog opens

    const handleCloseSelectMember = () => {
        setSelectMemberOpen(false);
        setSelectedMemberIds([]);
    };

    const handleCheckboxClick = (memberId: string, checked: boolean) => {

         if (checked) {
            const newSelections = selectedMemberIds.filter(id => 
                !familyMembers.some(m => m.id === id)
            ).length + 1;
            if(isAddFamilyMemberFlow && (newSelections > (MAX_FAMILY_MEMBERS - (navState?.obj?.membersCount + familyMembers.length)))){
                dispatch(showError(`Maximum ${MAX_FAMILY_MEMBERS} family members allowed`));
                return;
            }
            if (!isAddFamilyMemberFlow && ((familyMembers.length + newSelections) > MAX_FAMILY_MEMBERS)) {
                dispatch(showError(`Maximum ${MAX_FAMILY_MEMBERS} family members allowed`));
                return;
            }
        }
        setSelectedMemberIds((prev) =>
            checked
                ? (prev.includes(memberId) ? prev : [...prev, memberId])
                : prev.filter((id) => id !== memberId)
        );
    };

    // const handleAddMember = () => {
    //     const toAdd = members.filter((m) => selectedMemberIds.includes(m.id));
    //     const newIds = new Set(familyMembers.map((m) => m.id));
    //     const added = toAdd
    //         .filter((m) => !newIds.has(m.id))
    //         .map((m) => ({ ...m, consentStatus: "none" as ConsentStatus }));
    //     setFamilyMembers((prev) => [...prev, ...added]);
    //     if (added.length > 0 && !familyName) {
    //         setFamilyName(added[0].name);
    //     }
    //     if (added.length > 0 && !headOfFamilyId) {
    //         setHeadOfFamilyId(added[0].id);
    //     }
    //     handleCloseSelectMember();
    // };
    const handleAddMember = () => {
        // Deduplicate selected ids (row click + checkbox change can both fire)
        const uniqueSelectedIds = Array.from(new Set(selectedMemberIds));
        // Build new family list from current selection: keep existing row data for already-added members, add new ones with consentStatus "none"
        const newFamilyMembers: MemberRow[] = uniqueSelectedIds
            .map((id) => {
                const existing = familyMembers.find((m) => m.id === id);
                if (existing) return existing;
                const fromSearch = members.find((m) => m.customer === id);
                if (fromSearch) return {
                    id: fromSearch.customer,
                    name: fromSearch.customerName,
                    clientCode: fromSearch.customer,
                    investorPan: fromSearch.panNumber,
                    phoneNumber: fromSearch.mobileNo,
                    email: fromSearch.emailId,
                    consentStatus: "sendOtp" as ConsentStatus
                };
                return null;
            })
            .filter((m): m is MemberRow => m !== null);

        setFamilyMembers(newFamilyMembers);

        if (newFamilyMembers.length > 0 && !headOfFamilyId) {
            setHeadOfFamilyId(newFamilyMembers[0].id);
            if (!familyName) setFamilyName(newFamilyMembers[0].name);
        }


        handleCloseSelectMember();
    };


    const updateMemberStatus = (memberId: string, status: ConsentStatus, otpRef?: number) => {
        setFamilyMembers((prev) =>
            prev.map((m) => (m.id === memberId ? {
                ...m, consentStatus: status, otpReference: otpRef ?? m.otpReference
            } : m))
        );
    };

    const handleSendOtp = async (memberId: string) => {
        if (otpSendingMemberId === memberId) return;
        
        if (!isAddFamilyMemberFlow && !familyName.trim()) {
            dispatch(showError("Enter Family Name to proceed"));
            return;
        }

        if (isRMLikeRole(role) && !isAddFamilyMemberFlow && !isHofVerified && memberId !== headOfFamilyId) {
            dispatch(showError("Please verify Head of Family OTP first"));
            return;
        }

        const member = familyMembers.find((m) => m.id === memberId);
        try {
            setOtpSendingMemberId(memberId);
            const response = await (dispatch(sendFamilyOtp({
                clientCode: member?.clientCode ?? "",
                action: isAddFamilyMemberFlow ? "ADD" : "CREATE",
                isHeadOfFamily: isAddFamilyMemberFlow ? false : memberId === headOfFamilyId,
                familyName: isAddFamilyMemberFlow ? navState?.obj?.familyName : familyName,
                hofName: isAddFamilyMemberFlow ? navState?.obj?.familyHeadName : familyMembers.find(m => m.id === headOfFamilyId)?.name
            })) as unknown as Promise<SendFamilyOtpRes>);
            if (response?.isSuccess) {
                setOtpReference(response.otpReference);
                setOtpDialogMemberId(memberId);
                setOtpMessage(response.message);
                updateMemberStatus(memberId, "sendOtp", response.otpReference);
                setOtpDialogOpen(true);
            } else {
                dispatch(showError(response?.message ?? "Unable to send OTP"));
            }
        } catch (error) {
            dispatch(showError((error as Error)?.message ?? "Unable to send OTP"));
        } finally {
            setOtpSendingMemberId(null);
        }
    };

    const handleCloseOtpDialog = () => {
        setOtpDialogOpen(false);
        setOtpDialogMemberId(null);
        setOtpMessage("");
    };

    const handleSubmit = async (otp: string) => {
        if (!otpDialogMemberId || !otpReference) {
            dispatch(showError("Missing session details. Please resend OTP."));
            return;
        }

        try {
            const response = await (dispatch(verifyFamilyOtp({
                otp,
                otpReference: otpReference
            })) as unknown as Promise<VerifyFamilyOtpRes>);
            if (response?.isSuccess) {
                updateMemberStatus(otpDialogMemberId, "verified");
                if (role === USER_ROLES.INVESTOR && !isAddFamilyMemberFlow && familyName.trim()) {
                    setIsFamilyNameVerified(true);
                } else if (otpDialogMemberId === headOfFamilyId) {
                    setIsFamilyNameVerified(true);
                    setIsHofVerified(true); 
                }
                setOtpDialogOpen(false);
                setOtpDialogMemberId(null);
                setOtpReference(null);
            } else {
                dispatch(showError(response?.message ?? "Invalid OTP"));
            }
        } catch (error) {
            dispatch(showError((error as Error)?.message ?? "OTP verification failed"));
        }
    };

    const handleResendOtp = async () => {
        if (!otpDialogMemberId) return;
        const member = familyMembers.find((m) => m.id === otpDialogMemberId);
        if (!member?.clientCode) {
            dispatch(showError("Client code is missing for selected member"));
            return;
        }

        try {
            setOtpSendingMemberId(otpDialogMemberId);
            const response = await (dispatch(sendFamilyOtp({
                clientCode: member.clientCode,
                action: isAddFamilyMemberFlow ? "ADD" : "CREATE",
                isHeadOfFamily: isAddFamilyMemberFlow ? false : otpDialogMemberId === headOfFamilyId,
                familyName: isAddFamilyMemberFlow? navState?.obj?.familyName : familyName,
                hofName: isAddFamilyMemberFlow ? navState?.obj?.familyHeadName : familyMembers.find(m => m.id === headOfFamilyId)?.name
            })) as unknown as Promise<SendFamilyOtpRes>);
            if (response?.isSuccess) {
                setOtpReference(response.otpReference);
                setOtpMessage(response.message);
                updateMemberStatus(otpDialogMemberId, "sendOtp",  response.otpReference);
            } else {
                dispatch(showError(response?.message ?? "Unable to resend OTP"));
            }
        } catch (error) {
            dispatch(showError((error as Error)?.message ?? "Unable to resend OTP"));
        } finally {
            setOtpSendingMemberId(null);
        }
    };

    const handleFamilyMemberCreation = async () => {
        setIsSubmitting(true);
        try {

            if (!isAddFamilyMemberFlow && !familyName.trim()) {
                dispatch(showError("Enter Family Name to proceed"));
                setIsSubmitting(false);
                return;
            }

            if (!isAddMemberEnabled && role !== USER_ROLES.INVESTOR) {
                dispatch(showError("Ensure that OTP verification is completed for all the selected Investors"));
                return;
            }
            if (isAddFamilyMemberFlow) {
                const payload: AddRemoveFamilyMemberReq = {
                    action: "ADD",
                    familyId: navState?.obj?.familyID,
                    familyMembers: familyMembers.map((m) => ({
                        clientCode: m.clientCode,
                        otpReference: (!isAddFamilyMemberFlow && role === USER_ROLES.INVESTOR) ? null : (m.otpReference ?? 0),
                        isHeadOfFamily: false
                    }))
                };

                const response = await (dispatch(addRemoveFamilyMember(payload)) as unknown as Promise<AddRemoveFamilyMemberRes>);

                if (response?.isSuccess) {
                    if (role === USER_ROLES.INVESTOR) {
                        history.push(`/investor-family/family-profile/${navState?.obj?.familyID}`,
                            {
                                familyId: navState?.obj?.familyID,
                                obj: navState?.obj
                            }
                        );
                    } else {
                        history.push('/family/ViewFamily');
                    }
                } else {
                    dispatch(showError(response?.message ?? "Failed to add family member"));
                }
            } else {

                const payload: CreateFamilyPayload = {
                    familyName: familyName,
                    familyMembers: familyMembers.map((m) => ({
                        clientCode: m.clientCode,
                        otpReference: (!isAddFamilyMemberFlow && role === USER_ROLES.INVESTOR && familyMembers.indexOf(m) === 0) ? null : (m.otpReference ?? 0),
                        isHeadOfFamily: m.id === headOfFamilyId
                    }))
                };

                const response = await (dispatch(createFamily(payload)) as unknown as Promise<CreateFamilyRes>);

                if (response?.isSuccess) {
                    if (role === USER_ROLES.INVESTOR) {
                        history.push(`/investor-family/family-profile/${response.familyId}`,
                            {
                                familyId: response.familyId,
                                obj: navState?.obj
                            }
                        );
                    } else {
                        history.push('/family/ViewFamily');
                    }
                } else {
                    dispatch(showError(response?.message ?? "Ensure that OTP verification is completed for all the selected Investors"));
                }
            }
        } catch (error) {
            dispatch(showError(isAddFamilyMemberFlow ? "An error occurred while adding family member" : "An error occurred during family creation"));
        }
        finally {
            setIsSubmitting(false);
        }
    };
    const isCreateFamilyEnabled =
        familyMembers.length > 0 &&
        headOfFamilyId &&
          (role === USER_ROLES.INVESTOR && !isAddFamilyMemberFlow) 
            ? familyMembers.slice(1).every((m) => m.consentStatus === "verified" || !m.consentStatus) 
            : isRMLikeRole(role)
                ? familyMembers.some((m) => m.id === headOfFamilyId && m.consentStatus === "verified") 
                : familyMembers.every((m) => m.consentStatus === "verified"
    );

    const isAddMemberEnabled =
        familyMembers.length > 0 &&
        familyMembers.every((m) => m.consentStatus === "verified");

    const primaryTitle = isAddFamilyMemberFlow ? "Add Family Member" : "Create Family";

    const settingLoggedInUserDetails = () => {
        const loggedInUserObj = {
            id: clientInterfaceCode ?? "",
            name: displayInvestorName,
            clientCode: clientInterfaceCode ?? "",
            investorPan: panNo ?? "",
            phoneNumber: mobile ?? "",
            email: email ?? "",
            consentStatus: "" as ConsentStatus,

        }
        setFamilyMembers([loggedInUserObj]);
        setHeadOfFamilyId(clientInterfaceCode ?? "");
        setFamilyName(displayInvestorName)
    }

    useEffect(() => {
        if (role === USER_ROLES.INVESTOR && !isAddFamilyMemberFlow)
            settingLoggedInUserDetails()
    }, [])


    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <BreadCrum array={isRMLikeRole(role) ? rmRouterPath : investorRouterPath} />
            </Box>
            <Box mb="25px" mt={2}>
                <Typography variant='h1' color="text.primary">
                    {primaryTitle}
                </Typography>
            </Box>

            {isAddFamilyMemberFlow && (
                <Box sx={{
                    p: 1.2,
                    bgcolor: "background.paper",
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                    borderRadius: '10px',
                    mb: 3,
                    width: 'fit-content',
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                        <Typography variant="body_500" color="text.primary">
                            Family Code: {navState?.obj?.familyID ?? ""}
                        </Typography>
                        <Typography variant="body_500" color="text.primary">
                            Family Name: {navState?.obj?.familyName ?? ""}
                        </Typography>
                        <Typography variant="body_500" color="text.primary">
                            Head of Family: {navState?.obj?.familyHeadName ?? ""}
                        </Typography>
                    </Box>
                </Box>
            )}

            <Box
                sx={{
                    p: { xs: "1.5rem", sm: "1.2rem" },
                    bgcolor: "background.paper",
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                    borderRadius: '25px',
                    minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        p: 1,
                        bgcolor: 'customColors.seaShell',
                        borderRadius: '0.8rem',
                        mb: 2,
                    }}>
                    <InfoIconFilled />
                    <Typography variant="body_400" color="grey.800">
                        Here you can search by family members
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <TextField
                        name="searchText"
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                            sx: (theme: Theme) => ({
                                borderRadius: '0.4375rem',
                                height: '2.8125rem',
                                border: `1px solid ${theme.palette.text.secondary}B2`,
                                bgcolor: theme.palette.common.white,
                                '& fieldset': { border: 'none' },
                                '& input': {
                                    paddingLeft: '10px',
                                    ...theme.typography.body_500,
                                    color: theme.palette.grey[800],
                                    '::placeholder': {
                                        ...theme.typography.body_400,
                                        color: theme.palette.grey[800],
                                        opacity: 1,
                                    },
                                },
                            }),
                        }}
                        placeholder={role === USER_ROLES.INVESTOR ? "Search by  PAN , Client Code" : "Search by Name, PAN, Client Code"}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                    <Button
                        variant="outlined"
                        onClick={handleSearchClick}
                        disabled={!isSearchEnabled || isMembersLoading}
                        sx={(theme: Theme) => ({
                            borderRadius: '10px',
                            height: '47px',
                            px: 3,
                            bgcolor: theme.palette.primary[500],
                            color: theme.palette.common.white,
                            border: `1px solid ${theme.palette.primary[200]}`,
                            textAlign: 'center',
                            ...theme.typography.body_500,
                            lineHeight: '100%',
                            '&:hover': {
                                bgcolor: theme.palette.primary[500],
                                border: `1px solid ${theme.palette.primary[200]}`,
                                color: theme.palette.common.white,
                            },
                            '&:disabled': {
                                bgcolor: theme.palette.primary[100],
                                borderColor: theme.palette.primary[100],
                                color: theme.palette.common.white,
                            },
                        })}
                    >
                        {isMembersLoading ? (
                            <CircularProgress size={20} color="primary" />
                        ) : (
                            'Search'
                        )}

                    </Button>
                </Box>

                {familyMembers.length > 0 && (
                    <>
                        {!isAddFamilyMemberFlow && (
                            <TextField
                                label="Family Name"
                                name="familyName"
                                value={familyName}
                                disabled={isFamilyNameVerified}
                                onChange={(e) => setFamilyName(e.target.value)}
                                sx={{
                                    width: { xs: '100%', sm: '400px' }, mt: { xs: 3, sm: 2 },
                                    '& .MuiInputBase-input': {
                                        padding: '0.8rem 1rem',
                                    }
                                }}
                                InputProps={{
                                    sx: (theme: Theme) => ({
                                        borderRadius: '5px',
                                        padding: '0rem',
                                        ...theme.typography.body_500,
                                        '& fieldset': { borderColor: theme.palette.grey[200] },
                                        '&.Mui-focused fieldset': { borderColor: theme.palette.customColors.aumBlue },
                                          '&.Mui-disabled': {
                                            bgcolor: theme.palette.grey[50],
                                            color: theme.palette.text.primary,
                                        },
                                    }),
                                }}
                                InputLabelProps={{
                                    sx: { ...theme.typography.subtitle_400, color: 'grey.600' },
                                }}
                            />
                        )}
                        <Box
                            sx={{
                                borderRadius: '5px',
                                overflow: 'hidden',
                                bgcolor: 'background.paper',
                                mt: 5,
                            }}
                        >
                            <CustomTable
                                isLoading={false}
                                tableHeaderData={FamilyMembersTableHeader(
                                    isAddFamilyMemberFlow
                                )}
                                tableBody={
                                    <CreateFamilyMembersTableBody
                                        data={familyMembers}
                                        isAddFamilyMemberFlow={
                                            isAddFamilyMemberFlow
                                        }
                                        headOfFamilyId={headOfFamilyId}
                                        isHofVerified={isHofVerified} 
                                        onHeadOfFamilyChange={(id, name) => {
                                            setHeadOfFamilyId(id);
                                                if (!isFamilyNameVerified) {
                                                setFamilyName(name);
                                            }
                                        }}
                                        onSendOtp={handleSendOtp}
                                        isOtpLoading={otpSendingMemberId}
                                        onRemoveMember={(id) => {
                                            const updatedMembers = familyMembers.filter((m) => m.id !== id);
                                            setFamilyMembers(updatedMembers);
                                            if (updatedMembers.every(m => m.consentStatus !== "verified")) {
                                                setIsFamilyNameVerified(false);
                                                setIsHofVerified(false);
                                            }
                                        }}
                                    />
                                }
                                tableBodyCustomStyles={{
                                    '& tr:last-child td': {
                                        border: 0,
                                    },
                                    '& td:nth-of-type(7), & td:nth-of-type(8), & td:nth-of-type(9)': {
                                        paddingLeft: '10px',
                                    },
                                }}
                                tableHeadRowCustomStyles={{
                                    '& th': {
                                        borderBottom: `1px solid ${theme.palette.grey[100]}`,
                                        ...theme.typography.subtitle_400,
                                        color: 'grey.600',
                                        padding: 0,
                                    },
                                    '& th:nth-of-type(7), & th:nth-of-type(8), & th:nth-of-type(9)': {
                                        paddingLeft: '10px',
                                    },
                                }}
                                tableData={familyMembers}
                                tableDataCount={familyMembers.length}
                                isPaginationVisible={false}
                                loadingRowsNum={0}
                            />
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                mt: 4,
                            }}
                        >
                            <Button
                                variant="contained"
                                disabled={isSubmitting || (isAddFamilyMemberFlow ? !isAddMemberEnabled : !isCreateFamilyEnabled)}
                                onClick={handleFamilyMemberCreation}
                                sx={(theme: Theme) => ({
                                    ...theme.typography.body_500,
                                    color: theme.palette.common.white,
                                    lineHeight: '100%',
                                    borderRadius: '10px',
                                    bgcolor: theme.palette.primary[500],
                                    px: 4,
                                    py: 1.5,
                                    '&:hover': {
                                        bgcolor: theme.palette.primary[500],
                                    },
                                    '&.Mui-disabled': {
                                        bgcolor: theme.palette.primary[100],
                                        color: theme.palette.common.white,
                                    },
                                })}
                            >
                                {isSubmitting ? (
                                    <CircularProgress size={20} color="inherit" />
                                ) : (
                                    isAddFamilyMemberFlow ? "Add Member" : "Create Family"
                                )}
                            </Button>
                        </Box>
                    </>
                )}
            </Box>

            <Dialog
                open={selectMemberOpen}
                onClose={handleCloseSelectMember}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: (theme: Theme) => ({
                        borderRadius: '25px',
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                    }),
                }}
            >
                <DialogTitle sx={{ ...theme.typography.h1, color: 'text.primary', pb: 3 }}>
                    Select Member
                </DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            border: (t: Theme) => `1px solid ${t.palette.grey[200]}`,
                            borderRadius: '10px',
                            overflow: 'hidden',
                            bgcolor: 'background.paper',
                        }}
                    >
                        <CustomTable
                            isLoading={isMembersLoading}
                            tableHeaderData={selectMemberTableHeader}
                            tableBodyCustomStyles={{
                                '& tr:last-child td': {
                                    border: 0,
                                },
                            }}
                            tableHeadRowCustomStyles={{
                                '& th': {
                                    borderBottom: `1px solid ${theme.palette.grey[100]}`,
                                    ...theme.typography.subtitle_400,
                                    color: 'grey.600',
                                    padding: '0.8rem'
                                },
                            }}
                            tableBodyLoaderRowCustomStyles={{}}
                            tableBody={
                                <SelectMemberTableBody
                                    data={members}
                                    selectedMemberIds={selectedMemberIds}
                                    familyMemberIds={familyMembers.map(m => m.id)} 
                                    onCheckboxClick={handleCheckboxClick}
                                />
                            }
                            tableData={members}
                            tableDataCount={members.length}
                            isPaginationVisible={false}
                            loadingRowsNum={0}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, pt: 0, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={handleCloseSelectMember}
                        sx={(theme: Theme) => ({
                            borderRadius: '0.7rem',
                            padding: '0.5rem 0.8rem',
                            bgcolor: theme.palette.primary[500],
                            color: theme.palette.common.white,
                            border: `1px solid ${theme.palette.primary[200]}`,
                            ...theme.typography.body_500,
                            '&:hover': {
                                bgcolor: theme.palette.primary[500],
                                border: `1px solid ${theme.palette.primary[200]}`,
                                color: theme.palette.common.white,
                            },
                            '&:disabled': {
                                bgcolor: theme.palette.primary[100],
                                borderColor: theme.palette.primary[100],
                                color: theme.palette.primary[100],
                            },

                        })}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleAddMember}
                        disabled={selectedMemberIds.every(id => familyMembers.some(m => m.id === id))} 
                        sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            color: theme.palette.common.white,
                            padding: '0.5rem 0.8rem',
                            borderRadius: "10px",
                            bgcolor: theme.palette.primary[500],
                            '&:hover': {
                                bgcolor: theme.palette.primary[500],
                            },
                            '&.Mui-disabled': {
                                bgcolor: theme.palette.primary[100],
                                color: theme.palette.common.white,
                            },
                        })}
                    >
                        Add Member
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={otpDialogOpen}
                onClose={handleCloseOtpDialog}
                sx={(t: Theme) => ({
                    '& .MuiPaper-root': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: 530,
                        maxWidth: '100%',
                        padding: '24px',
                        borderRadius: '12px',
                        background: '#FFF',
                        boxShadow: `0px 4px 10px 0px ${t.palette.common.black}0D`,
                    },
                })}
            >
                <DialogContent sx={{ width: '100%' }}>
                    <OTPForm
                        onSubmit={handleSubmit}
                        onResend={handleResendOtp}
                        otpMessage={otpMessage}
                        warningMessage=""
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}